import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'

// Aura with light-mode text at WCAG 1.4.3 contrast (4.5:1). Aura's own shades fall short: white on
// emerald-500 and emerald-500 links are 2.5:1, red-500 is 3.8:1, the warning text 2.9:1 and muted
// text on grey 3.9:1. Same hues, one or two shades darker; dark mode is unchanged.
export const theme = definePreset(Aura, {
	semantic: {
		colorScheme: {
			light: {
				primary: {
					color: '{primary.700}',
					hoverColor: '{primary.800}',
					activeColor: '{primary.900}',
				},
				text: {
					mutedColor: '{surface.600}',
					hoverMutedColor: '{surface.700}',
				},
			},
		},
	},
	components: {
		// Flat cards with a hairline border (main.css) and a faint shadow; roomier bodies and
		// section-sized titles instead of Aura's 1.25rem headings.
		card: {
			root: {
				borderRadius: '12px',
				shadow: '0 1px 2px 0 rgba(15, 23, 42, 0.04)',
			},
			body: { padding: '1.5rem', gap: '1rem' },
			title: { fontSize: '16px', fontWeight: '600' },
		},
		datatable: {
			headerCell: { padding: '0.625rem 1rem' },
			bodyCell: { padding: '0.75rem 1rem' },
			colorScheme: {
				light: { headerCell: { background: '{surface.50}' } },
				dark: { headerCell: { background: '{surface.950}' } },
			},
		},
		tag: {
			root: {
				fontSize: '12px',
				fontWeight: '600',
				padding: '0.1875rem 0.5625rem',
				borderRadius: '999px',
			},
		},
		button: {
			colorScheme: {
				light: {
					root: {
						danger: {
							background: '{red.600}',
							hoverBackground: '{red.700}',
							activeBackground: '{red.800}',
							borderColor: '{red.600}',
							hoverBorderColor: '{red.700}',
							activeBorderColor: '{red.800}',
						},
					},
					outlined: { danger: { color: '{red.600}' } },
					text: { danger: { color: '{red.600}' } },
				},
			},
		},
		message: {
			colorScheme: {
				light: {
					warn: {
						color: '{yellow.800}',
						outlined: { color: '{yellow.800}' },
						simple: { color: '{yellow.800}' },
					},
					error: {
						color: '{red.700}',
						outlined: { color: '{red.700}' },
						simple: { color: '{red.700}' },
					},
					success: {
						color: '{green.700}',
						outlined: { color: '{green.700}' },
						simple: { color: '{green.700}' },
					},
				},
			},
		},
		togglebutton: {
			colorScheme: {
				light: {
					root: { color: '{surface.600}' },
					icon: { color: '{surface.600}' },
				},
			},
		},
	},
})
